// extracted by mini-css-extract-plugin
export default {"wrap":"Wx-z","fullWidth":"Xx-z","searchPlacement":"Yx-z","items":"Zx-z","featureCss":"_x-z","disabled":"ay-z","imgCss":"by-z"};